import { action } from '@ember/object';
import SettingsRolesBaseController from '../base';
import RoleModel from 'scaleflow/models/role';

export default class SettingsRolesRoleEditController extends SettingsRolesBaseController {
  declare model: RoleModel;

  @action
  cancel() {
    // Rollback changes to avoid persisting unsaved changes
    (this.model as any).rollbackAttributes();
    this.goToListPage();
  }
}
